export class RfqSessionNudgeSettingTriggerTimingTargetType {
	public id: number;
	public name: string;

	constructor(rfqSessionNudgeSettingTriggerTimingTargetType?: RfqSessionNudgeSettingTriggerTimingTargetType) {
		Object.assign(this, rfqSessionNudgeSettingTriggerTimingTargetType);
	}
}
